import { HandleCopy, Request, Translation } from '@/helpers'
import { ENDPOINTS } from '@/data'

const Copy = async (SetState: Function, componentId: ComponentInterface, Notification: Function) => {
    try {
        SetState({ Copying: componentId })

        const { success, data, message } = await Request({
            path: ENDPOINTS.INIT_COPY,
            method: 'POST',
            body: {
                componentId
            }
        })

        if (success && data) HandleCopy(data, Notification)
        else Notification(message)
    }

    catch (error) {
        console.error(error)
        Notification(Translation('something-went-wrong-while-trying-to-copy-component'))
    }

    finally {
        SetState({ Copying: false })
    }
}

export default Copy
